import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { SinglePluginRule } from './single-plugin-rule/single-plugin-rule';
import { AllPluginsRule } from './all-plugins-rule/all-plugins-rule';
import { InternalRepoPluginsRule } from './internal-repo-plugins-rule/internal-repo-plugins-rule';
import { VendorPluginsRule } from './vendor-plugins-rule/vendor-plugins-rule';
export const PluginsRule = memo(function PluginsRule(props) {
    const { rule, onRuleChange, ...basePluginRuleProps } = props;
    switch (rule.type) {
        case 'all-plugins': {
            return _jsx(AllPluginsRule, { rule: rule, onRuleChange: onRuleChange, ...basePluginRuleProps });
        }
        case 'vendor-plugins': {
            return _jsx(VendorPluginsRule, { rule: rule, onRuleChange: onRuleChange, ...basePluginRuleProps });
        }
        case 'internal-repo': {
            return (_jsx(InternalRepoPluginsRule, { rule: rule, onRuleChange: onRuleChange, ...basePluginRuleProps }));
        }
        case 'single-plugin': {
            return _jsx(SinglePluginRule, { rule: rule, onRuleChange: onRuleChange, ...basePluginRuleProps });
        }
        default:
            assert_exhaustive(rule);
    }
});
